import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { formatPrice } from '@codex/helpers';
import { EnvironmentThemeProvider } from '@codex-brightworld/themes';

const StyledRibbon = styled.div`
  display: table;
  padding: 4px 12px;
  font-family: CurrysSans, Helvetica;
  font-size: 12px;
  background-color: ${(props) => props.theme.colors.primary.magenta};
  color: #fff;
  border-radius: 2px;
`;

const BuyTogetherRibbon = ({ price, currency }) => {
  if (price === 0) {
    return null;
  }

  return (
    <EnvironmentThemeProvider>
      <StyledRibbon>
        Buy together:
        {' '}
        <strong>
          Save
          {' '}
          {formatPrice(price, true, currency)}
        </strong>
      </StyledRibbon>
    </EnvironmentThemeProvider>
  );

};

BuyTogetherRibbon.propTypes = {
  price: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired
};

export default BuyTogetherRibbon;
